export enum OptieStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  HIDDEN = 'HIDDEN',
}
